<div class="webapp-page-container">
  <div class="page-header">
    <div class="title-page">Admin Panel</div>
    <div class="flex items-center gap-4">
      <app-simple-button size="large" routerLink="/webapp">Go Back to Buildevo</app-simple-button>
      <app-search-input
        class="w-[360px]"
        [verticalSpacing]="false"
        (searchText)="registerSearch($event)"
      ></app-search-input>
    </div>
  </div>

  <div class="content">
    @if (users.length === 0) {
      {{ statusMessage }}
    } @else {
      <div class="user-row header">
        <div class="item">Last Login</div>
        <div class="item">Username</div>
        <div class="item">Type</div>
        <div class="item">First Name</div>
        <div class="item">Last Name</div>
        <div class="item">Company Name</div>
        <div class="item">Phone Number</div>
        <div class="item">Email</div>
        <div class="item">Status</div>
      </div>
      <cdk-virtual-scroll-viewport class="table-wrapper" itemSize="60">
        <div
          [ngClass]="{ 'with-verify-btn': !item?.email_verified_at }"
          *cdkVirtualFor="let item of users"
          class="user-row"
          [formGroup]="userForm"
        >
          <div class="item">
            {{ dayjs(item.last_login).utc().format('MM/DD/YY HH:mm') }}
          </div>
          <div class="item">{{ item.username }}</div>
          <div class="item">
            @if (item.type) {
              @if (item.type.id === 1) {
                <span>Contractor</span>
              }
              @if (item.type.id !== 1) {
                <span> Manager </span>
              }
            }
          </div>
          @if (item.id !== editId) {
            <div class="item">
              <span [appTooltip]="item.first_name" tooltipPosition="bottom">{{ item.first_name }}</span>
            </div>
            <div class="item">
              <span [appTooltip]="item.last_name" tooltipPosition="bottom">{{ item.last_name }}</span>
            </div>
            <div class="item">
              <span [appTooltip]="item.company_name" tooltipPosition="bottom">{{ item.company_name }}</span>
            </div>
            <div class="item">
              <span [appTooltip]="item.phone" tooltipPosition="bottom">{{ item.phone }}</span>
            </div>
            <div class="item">
              <span [appTooltip]="item.email" tooltipPosition="bottom">{{ item.email }}</span>
            </div>
            @if (!item?.is_approved) {
              <div>Not Accepted</div>
            }
            @if (!!item?.is_approved) {
              <div>Accepted</div>
            }
          } @else {
            <app-floating-input [verticalSpacing]="false" placeholder="Last Name" formControlName="last_name" />

            <app-floating-input [verticalSpacing]="false" placeholder="First Name" formControlName="first_name" />

            <app-floating-input [verticalSpacing]="false" placeholder="" formControlName="company_name" />

            <app-floating-input [verticalSpacing]="false" placeholder="" formControlName="phone" />

            <app-floating-input [verticalSpacing]="false" placeholder="" formControlName="email" />

            <app-floating-input [verticalSpacing]="false" formControlName="password" placeholder="New Password" />
          }

          @if (!item.is_approved) {
            <button matTooltip="approve account" (click)="acceptUser(item)" class="btn-small !bg-green-600" mat-button>
              Accept
            </button>
          } @else {
            <div></div>
          }
          @if (!item?.email_verified_at) {
            <button
              matTooltip="verify email address manually"
              (click)="verifyEmail(item)"
              class="btn-small !bg-yellow-500"
              mat-button
            >
              Verify
            </button>
          } @else {
            <div></div>
          }
          <button (click)="deleteUser(item)" class="btn-small !bg-red-500" mat-button>Delete</button>
          @if (item.id == editId) {
            <button (click)="saveUser(item)" class="btn-small !bg-navy-900" mat-button>Save</button>
          }
          @if (item.id != editId) {
            <button (click)="editUser(item)" class="btn-small !bg-navy-900" mat-button>Edit</button>
          }
          <!--        <div>{{item.username}}</div>-->
        </div>
      </cdk-virtual-scroll-viewport>
    }
  </div>
</div>
